// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39UAj","label":"styles_label__3hHIG"};